import React from 'react';
import { ClipLoader } from 'react-spinners';
import './Loading.css'; 

const LoadingOverlay = ({ isLoading, message = "Loading..." }) => {
    if (!isLoading) return null;

    return (
        <div className="loading-overlay">
            <div className="loading-content">
                <ClipLoader color="#36d7b7" size={50} />
                <p>{message}</p>
            </div>
        </div>
    );
};

export default LoadingOverlay;